<template>
  <div style="width: 100%">
    <employees-table
      :employees="employeesAll"
      :tagCategories="tagCategories"
      :loading="$apollo.loading"
      :showCounters="false"
      @refresh="$apollo.queries.employeesAll.refresh()"
      class="mt-3"
    />
  </div>
</template>

<script>
import EmployeesTable from "@/components/employee/EmployeesTable.vue";

import AllEmployeesDetailedQuery from "@/graphql/queries/employee/AllEmployeesDetailed.gql";
import TagCategoriesQuery from "@/graphql/TagCategories.gql";

import {
  createTagCategories,
  createEmployeesSearch,
  getMissingParentTags,
} from "@/utils/common.js";
import { mapGetters } from "vuex";

export default {
  components: {
    EmployeesTable,
  },

  computed: {
    ...mapGetters(["employeeHeaders"]),
  },

  apollo: {
    tagCategories: {
      query: TagCategoriesQuery,
    },
    employeesAll: {
      query: AllEmployeesDetailedQuery,
      update(data) {
        return (
          data.employeesAll &&
          data.employeesAll.map((e) => {
            const missingParentTags = getMissingParentTags(e);
            const search = `${createEmployeesSearch(e, this.employeeHeaders)}${
              missingParentTags.length ? "|*" : ""
            }`;
            return {
              ...e,
              search,
              ...createTagCategories(this.tagCategories, e.tags),
              missingParentTags,
            };
          })
        );
      },
      skip() {
        return !this.tagCategories;
      },
    },
  },
};
</script>
